/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   SavedCustomMessageToggle.ts
 */
/** @jsx jsx */

import { useId } from '@chakra-ui/react'
import { jsx } from '@emotion/react'
import { Switch } from '@zcode-ui/controls'
import { event, toTraktorEventName } from '@zcode-ui/web-zumper-integrations'
import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  SAVED_CUSTOM_MESSAGE_TOGGLE_TEXT,
  SAVED_CUSTOM_MESSAGE_TRAKTOR_ACTIONS,
  SAVED_CUSTOM_MESSAGE_TRAKTOR_CATEGORY,
} from '../constants'
import { setCustomMessageChecked } from '../module/actions'
import { selectCustomMessageChecked, selectCustomMessageHasBeenChecked } from '../module/selectors'

import * as styles from './styles'

export const SavedCustomMessageToggle = () => {
  const dispatch = useDispatch()
  const customMessageChecked = useSelector(selectCustomMessageChecked)
  const customMessageHasBeenChecked = useSelector(selectCustomMessageHasBeenChecked)

  const switchId = useId()

  const setChecked = useCallback(() => {
    const isChecked = !customMessageChecked

    dispatch(
      event({
        name: toTraktorEventName(SAVED_CUSTOM_MESSAGE_TRAKTOR_CATEGORY),
        // @ts-expect-error props should be an object, not a string
        props: isChecked
          ? SAVED_CUSTOM_MESSAGE_TRAKTOR_ACTIONS.TOGGLE_ON
          : SAVED_CUSTOM_MESSAGE_TRAKTOR_ACTIONS.TOGGLE_OFF,
      })
    )

    dispatch(setCustomMessageChecked(isChecked))
  }, [customMessageChecked])

  if (!customMessageHasBeenChecked) {
    return null
  }

  return (
    <label css={styles.savedCustomMessageToggle} htmlFor={switchId}>
      <div css={styles.savedCustomMessageToggleText}>{SAVED_CUSTOM_MESSAGE_TOGGLE_TEXT}</div>
      <Switch<'input'> id={switchId} isChecked={customMessageChecked} onChange={setChecked} />
    </label>
  )
}
